// Auto animate for demo

const toggle = document.querySelector(".hamburger-toggle input");

if (toggle) {
  const animate = setInterval(() => {
    toggle.checked = !toggle.checked;
  }, 3000);
}
